import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './http';

/** 4xx повторять бессмысленно (нет доступа, нет данных) — только сетевые сбои и 5xx. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: false,
      retry: (count, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
        return count < 2;
      },
    },
  },
});
